import React, { useEffect, useState } from "react";
import AuthServices from "../../../api/VoucherServices";
import { useAuth } from "../../../context";
import { useNavigate } from "react-router-dom";
import Images from "../../../assets/images"; // 👈 Make sure you have this import path correct

const LoaderRegistration = () => {
  const [showLoader, setShowLoader] = useState(true);
  const { userLogin } = useAuth();
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  const navigate = useNavigate();

  const getVendorAuth = async () => {
    localStorage.clear();
    const startTime = Date.now();

    try {
      let obj = { token };
      console.log("📦 Request payload:", obj);

      const { data } = await AuthServices.getVendorAuth(obj);
      console.log("✅ API Response:", data);
      userLogin(data);

      if (data) {
        console.log(data?.active_step);
        navigate("/vendor", {
          state: data?.active_step, // 👈 pass your custom state
        });
      }
    } catch (error) {
      console.error("❌ API Error:", error);
    } finally {
      const elapsed = Date.now() - startTime;
      const remaining = 5000 - elapsed;

      if (remaining > 0) {
        setTimeout(() => setShowLoader(false), remaining);
      } else {
        setShowLoader(false);
      }
    }
  };

  useEffect(() => {
    getVendorAuth();
  }, []);

  if (!showLoader) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#0F172A",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <img
        src={Images.loader}
        alt="Loading..."
        style={{
          width: "120px", // adjust size as needed
          height: "120px",
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default LoaderRegistration;
